import { Injectable } from "@angular/core";
import { OverviewApiService } from "src/api/services/overview-api.service";
import { Observable } from "rxjs";
import {
    AllocationOverviewConfirmationCheck,
    MissingPartDetails,
    Overview,
    SimulationOverview,
    BookClosureDetails,
} from "./state-models/overview-data";

@Injectable()
export class OverviewStateService {
    constructor(private apiService: OverviewApiService) {}

    public GetByAllocationType(allocationType: number): Observable<Overview[]> {
        return this.apiService.GetByAllocationType(allocationType);
    }
    public GetSimulation(): Observable<SimulationOverview> {
        return this.apiService.GetSimulation();
    }

    public GetBookClosure(): Observable<BookClosureDetails> {
        return this.apiService.GetBookClosureDetail();
    }

    public GetSimulationMissingPart(
        from: string,
        to: string,
        marketId: number,
        slaMarketId: number,
    ): Observable<MissingPartDetails> {
        return this.apiService.GetSimulationMissingPart(
            from,
            to,
            marketId,
            slaMarketId,
        );
    }

    SaveAllocationOverviewConfirmationCheck(
        allocationOverviewConfirmationCheck: AllocationOverviewConfirmationCheck,
    ) {
        return this.apiService.SaveAllocationOverviewConfirmationCheck(
            allocationOverviewConfirmationCheck,
        );
    }
}
